// 摄像头评估详情
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import columns from './columns'
import './index.less'
const { WizSpin, WizAntdForm, WizInput, WizButton, WizCard, WizTable } = component_tool
const { Item } = WizAntdForm
const { WizContainer } = framework_tool
const { Session } = utils_tool

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = WizAntdForm.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = e => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      this.toggleEdit();
      handleSave({ ...record, ...values });
      // if (error && error[e.currentTarget.id]) {
      //   return;
      // }
    });
  };

  renderCell = form => {
    this.form = form;
    const { dataIndex, record } = this.props;
    return (
      <Item style={{ margin: 0 }} className='feedback-item'>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `请输入点评信息`,
            },
          ],
          initialValue: record[dataIndex],
          getValueFromEvent: (e) => {
            return e.target.value.replace(/\s+/g, '')
          },
        })(<WizInput ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save} onFocus={this.toggleEdit} />)}
      </Item>
    )
  };

  render() {
    const {
      editable,
      dataIndex,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/cameraEvaluation/comment') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackCameraEvaluationComment', record)
    } else {
      record = Session.get('trackCameraEvaluationComment') || {}
    }
  }
  return record
}

class TrackCameraEvaluationComment extends WizContainer {

  componentName = 'TrackCameraEvaluationComment'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      data: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, rowInfo } = this.state.record
    this.doAction({
      path: 'counselingProcess/cameraCheckLookCheckList',
      payload: {
        key: 'cameraCheckLookCheckList@' + processContentId,
        apiParams: {
          trackCameraId: rowInfo.id
        }
      }
    })
  }

  saveList = (params) => {
    const { processContentId } = this.state.record
    this.doAction({
      path: 'counselingProcess/cameraCheckSaveCommentCheckList',
      payload: {
        key: 'cameraCheckSaveCommentCheckList@' + processContentId,
        apiParams: {
          ...params
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    saveList: this._saveList.bind(this)
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取摄像头点评列表失败')
    return false
  }

  _saveList(nextProps, nextState) {
    let { saveList } = nextProps
    let { success, msg } = saveList
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '摄像头点评失败')
    return false
  }

  _renderTable = () => {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    let { data } = this.state
    const tableProps = {
      components: components,
      loading: false,
      columns: columns.map(col => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: record => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            handleSave: this.handleSave,
          }),
        };
      }),
      dataSource: data,
      pagination: false,
      bordered: true,
      size: 'middle',
      rowKey: (record, index) => index,
    }
    return <WizTable {...tableProps} />
  }

  handleSave = row => {
    const newData = [...this.state.data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    this.setState({ data: newData });
  };

  // 提交点评
  handleSubmit = () => {
    let { data, record } = this.state
    let someData = data.some(e => e.commentContent == '')
    if (someData) {
      wizNotice.warning('请填写点评信息')
    } else {
      this.saveList({
        trackCameraId: record['rowInfo']['id'],
        list: data
      })
    }
  }

  render() {
    let { counselingProcessLoading } = this.props
    return (
      <WizSpin spinning={counselingProcessLoading} >
        <WizCard title='摄像头检核点评'>
          {this._renderTable()}
          <div className='form-btn'>
            <WizButton type='primary' htmlType='submit' onClick={() => this.handleSubmit()}>
              提交
            </WizButton>
          </div>
        </WizCard>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'cameraCheckLookCheckList@' + processContentId)
  const saveList = modelUtils.getModelEntity(counselingProcess, 'cameraCheckSaveCommentCheckList@' + processContentId)
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    saveList,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackCameraEvaluationComment)
